interface ObjectTypeConfig {
  bg: string;
  fg: string;
}

// Kanonske vrijednosti objectType koje backend stvarno sprema (vidi seed
// podatke — 'ship', 'oil_platform'). Select u formi nudi samo ove
// vrijednosti; prikazani label je uvijek preveden, nikad sirova vrijednost
// iz baze.
export const OBJECT_TYPES: { value: string; labelKey: string }[] = [
  { value: 'ship', labelKey: 'objectRegistry.typeShip' },
  { value: 'oil_platform', labelKey: 'objectRegistry.typeOilPlatform' }
];

const objectTypeConfig: Record<string, ObjectTypeConfig> = {
  ship: {
    bg: 'var(--color-status-success-soft)',
    fg: 'var(--color-status-success)'
  },
  oil_platform: {
    bg: 'var(--color-role-user-soft)',
    fg: 'var(--color-role-user)'
  }
};

const defaultTypeConfig: ObjectTypeConfig = {
  bg: 'var(--color-bg-surface-2)',
  fg: 'var(--color-text-secondary)'
};

export const getObjectTypeConfig = (type?: string): ObjectTypeConfig =>
  (type && objectTypeConfig[type]) || defaultTypeConfig;

/** Nepoznate/stare vrijednosti (npr. podaci uneseni prije uvođenja dropdowna)
 * prikazuju sirovu vrijednost kao fallback umjesto da nestanu iz prikaza. */
export const formatObjectType = (t: (key: string) => string, type?: string): string => {
  const match = OBJECT_TYPES.find((o) => o.value === type);
  return match ? t(match.labelKey) : (type ?? '—');
};

export const objectStatusConfig = {
  active: {
    labelKey: 'objectRegistry.statusActive',
    bg: 'var(--color-status-success-soft)',
    fg: 'var(--color-status-success)'
  },
  inactive: {
    labelKey: 'objectRegistry.statusInactive',
    bg: 'var(--color-bg-surface-2)',
    fg: 'var(--color-text-secondary)'
  }
};

/**
 * Oznaka objekta u dropdownima i prikazima: "šifra - naziv". Ako jedno od toga fali, samo ono
 * što postoji (bez crtice); ako fale oba, "—".
 */
export const formatObjectLabel = (object: {
  objectCode?: string | null;
  objectName?: string | null;
}): string =>
  [object.objectCode?.trim(), object.objectName?.trim()].filter(Boolean).join(' - ') || '—';
